export default "__VITE_ASSET__DCisE_Zq__"